import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const InfoIcon = (props: IIconProps) => {
  const { width = 38, height = 37, color = 'currentColor' } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 38 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 32.375C26.663 32.375 32.875 26.163 32.875 18.5C32.875 10.837 26.663 4.625 19 4.625C11.337 4.625 5.125 10.837 5.125 18.5C5.125 26.163 11.337 32.375 19 32.375Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.8438 17.3438H19V25.4375H20.1562" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.7109 13.875C19.6688 13.875 20.4453 13.0985 20.4453 12.1406C20.4453 11.1828 19.6688 10.4062 18.7109 10.4062C17.7531 10.4062 16.9766 11.1828 16.9766 12.1406C16.9766 13.0985 17.7531 13.875 18.7109 13.875Z" fill={color} />
    </svg>
  );
};

export default memo(InfoIcon);
